<template>
<!-- 首页 -->
  <div class="pc_page">
    <Header></Header>
    <div class="banner_top">
      <el-carousel arrow="never" height="600px">
        <el-carousel-item class="carousel-item" v-for="(item, index) in bannerList" :key="index">
          <div class="pic_item">
            <span class="english_first_title">{{ item.english_first_title }}</span>
            <span class="english_secord_title">{{ item.english_secord_title }}</span>
            <span class="title">{{ item.title }}</span>
            <img :src='item.imgUrl' style="max-width:100%;max-height:100%;" alt="">
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- banner E -->
    <div class="product">
      <div class="product_top">
        <p class="product_title">产品案例</p>
        <p class="product_en_title">Product Case</p>
        <div class="line"></div>
      </div>
      <div class="product_img">
        <div class="product_img_first" @click="goProductDetail(11)">
          <div class="product_img_text">
            <p class="product_img_title">企业数字档案系统</p>
            <p class="product_img_info">为了更好的扶持自贸区企业的发展，提供更全面更便捷的服务</p>
          </div>
          <!-- <img src="../assets/images/bg_img01.png" class="mask" alt=""> -->
          <img src="../assets/images/1.jpg" class="img" alt="">
          <div class="img_bg"></div>
        </div>
        <div class="product_img_first" style="margin-left:1%;width:40%" @click="goProductDetail(19)">
          <div class="product_img_text">
            <p class="product_img_title">企金服</p>
            <p class="product_img_info">为了更好的扶持自贸区企业的发展</p>
          </div>
          <!-- <img src="../assets/images/bg_img01.png" class="mask" alt=""> -->
          <img src="../assets/images/5.jpg" class="img" alt="">
          <div class="img_bg"></div>
        </div>
      </div>
      <div class="product_img2">
        <div class="oversize" @click="goProductDetail(10)">
          <img src="../assets/images/3.jpg" alt="">
          <div class="img_bg"></div>
        </div>
        <div class="oversize" @click="goProductDetail(18)">
          <img src="../assets/images/4.jpg" alt="">
          <div class="img_bg"></div>
        </div>
        <div class="oversize" @click="goProductDetail(20)">
          <img src="../assets/images/2.jpg" alt="">
          <div class="img_bg"></div>
        </div>
      </div>
    </div>
    <!-- 产品案例 E -->
    <div class="banner_center">
      <div class="btn_box">
        <div class="swiper-button-prev" slot="button-prev"><img src="../assets/images/left.png" alt=""></div>
          <div class="swiper-button-next" slot="button-next"><img src="../assets/images/right.png" alt=""></div>
      </div>
      <swiper :options="swiperOption">
        <swiper-slide v-for="(item,index) in mediaNews" :key="index">
          <div class="box_img" v-if="item.type == 0">
            <span>迎接风雪</span>
            <b class="ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="0.7s" swiper-animate-delay="0.3s">最好的姿态</b>
            <span class="more ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="0.9s" swiper-animate-delay="0.5s">更多精彩></span>
            <img :src="item.url" style="width:100%;height:100%;object-fit:cover;">
          </div>
          <div class="box_img" v-if="item.type == 1">
            <span>迎接风雪</span>
            <b class="ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="0.7s" swiper-animate-delay="0.3s">最好的姿态</b>
            <span class="more ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="0.9s" swiper-animate-delay="0.5s">更多精彩></span>
            <video v-if="item.type===1"
                  :src="item.url"
                  controls
                  muted
                  class="multimedia"
                  :id="'video_player'+index"
                  style="width:100%;height:100%;object-fit:fill;"
            ></video>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>

    <button @click="videoPlay">播放</button>
    </div>
    <!-- 中间banner E -->
    <div class="company">
      <div class="company_top">
        <p class="company_title">公司动态</p>
        <p class="company_en_title">Company dynamics</p>
        <div class="line"></div>
      </div>
      <div class="company_content">
        <div class="company_card" v-for="(item, index) in articleList" :key='index'>
          <router-link :to=" { path:'/newsDetails', query: {id: item.id} } ">
            <div class="oversize">
              <img :src="item.image" alt="">
            </div>
            <p class="company_title_text">{{ item.topic }}</p>
            <p class="company_info">{{ item.description }}</p>
          </router-link>
        </div>
      </div>
      <div class="btn">
        <el-button class="news_btn"><router-link :to=" { path:'/newsList' }" style="color: #2D58C6;" >更多新闻</router-link></el-button>
      </div>
    </div>
    <!-- 公司动态 E -->
    <Footer></Footer>
  </div>
</template>
 
<script>
import Header from "./header.vue"
import Footer from "./footer.vue"
import {swiperAnimateCache,swiperAnimate} from "../assets/js/swiper.animate1.0.3.min.js"
import { getArticleList } from "@/api/app.js";
export default {
  name: "HelloWorld",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      queryParams: {
        limit: 3,
        page: 1
      },
      articleList: [],
      bannerList: [
        {
          imgUrl: require("../assets/images/banner2.jpg"),
          english_first_title: 'Blockchain',
          english_secord_title: 'information security leader',
          title: '区块链信息安全引领者',
        },
        {
          imgUrl: require("../assets/images/banner3.jpg"),
          english_first_title: 'Pioneer in the',
          english_secord_title: 'field of big data technology',
          title: '大数据技术领域开拓者',
        },
        {
          imgUrl: require("../assets/images/banner4.jpg"),
          english_first_title: 'The creator of',
          english_secord_title: 'the whole value chain credit ecosystem',
          title: '全价值链信用生态系统创造者',
        },
        
      ],
      mediaNews: [
        {
          url: require("../assets/video/qiye.mp4"),
          type: 1,
        },
        // {
        //   url: require("../assets/video/jiejue.mp4"),
        //   type: 1,
        // },
        {
          url: require("../assets/images/video1.jpg"),
          type: 0,
        },
        {
          url: require("../assets/images/video2.jpg"),
          type: 0,
        },
        {
          url: require("../assets/images/video3.jpg"),
          type: 0,
        },
      ],
      swiperOption: {
        direction: "horizontal",
        loop: true,
        on:{
          init: function() {
            swiperAnimateCache(this); //隐藏动画元素 
            swiperAnimate(this); //初始化完成开始动画
          }, 
          slideChangeTransitionEnd: function(){ 
            swiperAnimate(this); //每个slide切换结束时也运行当前slide动画
          },
          slideChange: () => {
            // console.log('改变了，activeIndex为'+this.activeIndex);
            var video = document.getElementById("video_player0");
            console.log(video);
            video.play();
          },
        },
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          // type: 'custom',
          clickable: true,
          bulletClass: 'my-bullet',
          bulletActiveClass: 'my-bullet-active'
        },
      },
      currentIndex: -1,
    };
  },
  mounted() {
    
  },
  created() {
    this.getArticleList();
  },
  methods: {
    videoPlay() {
      // this.$refs.video_player0.play();
      // return;
      var video = document.getElementById("video_player0");
      console.log(video);
      video.play();
    },
    slideChangeTransitionEndHandle() {
      return;
      console.log('end..')
      let that = this
      let swiper = that.$refs.videoSwiper.swiper;
      if (swiper == null) {
        return;
      }
      // console.log(swiper.activeIndex);
      document.getElementsByClassName('multimedia')[0].play()
      return;
      if (this.mediaNews[swiper.activeIndex].type === 0) {
        this.mediaNewsImgHandle(swiper)
      } else {
        console.log(123);
        if(this.mediaLastIndex.type === 1){
          document.getElementsByClassName('multimedia')[this.mediaLastIndex].pause()
        }
        document.getElementsByClassName('multimedia')[swiper.activeIndex].play()
      }
      this.mediaLastIndex=swiper.activeIndex
      console.log(this.mediaLastIndex)
    },
    // 获取新闻列表
    getArticleList() {
      getArticleList(this.queryParams).then(res => {
        this.articleList = res.list;
      });
    },
    itemClick(i){
        this.currentIndex = i
        console.log(this.currentIndex)
    },
    // 跳转产品详情页
    goProductDetail(id) {
      this.$router.push({
        path: 'productDetails',
        query: {id: id}
      });
    },
      
  },
};
</script>

<style scoped>
@import url("../assets/css/index.css");
@import url('../assets/css/animate.min.css');


.carousel-item {
    width: 100%;
    height: 100%;
    background: white;
    display: flex;
    justify-content: center;
  }

.pc_page .company .company_content .company_card[data-v-469af010]:hover {
  color: #2d58c6;
  cursor: pointer;
}

.ani{
    position:absolute
}


.my-bullet{
    
    background: #520ae2;
    opacity: 1;
    
  }
  .my-bullet-active{
    background: #ec1109;
    opacity: 1;
  }


    /* .swiper-wrapper{
    height: 720px;
    } */
  .swiper-slide {
      width:1200px;
        transition-timing-function:linear;
    height: 720px;
  }
    

    .swiper-slide img{
        width:100%;
    height: 720px;
        border-radius: 4px;
  }
    .swiper-slide .title{
        position:absolute;
        transform:rotate(90deg);
        transform-origin:left top;
        left:-3px;
        font-size:11px;
        color: rgb(102, 102, 102);
  } 
  .swiper-button-next, .swiper-button-prev{
        width:86px;
        height:112px;
        background-size:86px 112px;
        margin-top:-56px;

        outline:none;
  }
    .swiper-button-next{
    background-image:none;
    display:flex;
    align-items:center;
    justify-content:center;
    width:48px;
    height:48px;
    border-radius:100%;
    transition:all 0.3s ease;
    margin:0;
  }
    .swiper-button-prev{
    background-image:none;
    display:flex;
    align-items:center;
    justify-content:center;
    width:48px;
    border-radius:100%;
    height:48px;
    transition:all 0.3s ease;
    margin:0;
    top:0;
  }
  .swiper-button-prev img,.swiper-button-next img{display:block;width:10px;height:20px;}
  .swiper-button-prev:hover,.swiper-button-next:hover{background:rgba(0,0,0,0.5)}
  .progress {
    opacity: 1;
    width: 16px;
    height: 2px;
    background-color: rgba(255,255,255,.3);
    border-radius: 60px;
    position: relative;
    overflow: hidden;
  }


  .banner_center{margin-bottom:20px;position: relative;}
  .btn_box{position: absolute;bottom:0;left:0;right:0;top:0;margin:auto;width:1200px;height:48px;}
  .banner_center .swiper-pagination{font-size:0;line-height:100%;bottom:20px;width:100%;height:2px;display:flex;align-items:center;justify-content:center;}
  .banner_center .swiper-pagination /deep/ .my-bullet{display:block;width:16px;height:2px;background:rgba(255,255,255,0.3);margin:0 2px; cursor: pointer;}
  .banner_center .swiper-pagination /deep/ .my-bullet.my-bullet-active{background:#fff; cursor: pointer;}
  .box_img{position: relative;}
  .box_img span{position: absolute;top:40px;width:100%;display:block;text-align:center;font-size:40px;line-height:44px;color:#fff;}
  .box_img b{position:absolute;top:100px;text-align:center;width:100%;font-size:40px;line-height:44px;color:#fff;font-weight:normal;}
  .box_img .more {position:absolute;top: 170px;text-align: center;width: 100%;font-size: 18px;line-height: 30px;color: #fff;font-weight:normal;cursor: pointer;}
  .pic_item {position: relative;width: 100%;}
  .pic_item .english_first_title {color: #555555;font-weight: 500;display: block;position: absolute;left: 240px;top: 220px;text-align: center;font-size: 36px;line-height: 40px;}
  .pc_page .english_secord_title {color: #555555;font-weight: 600;display: block;position: absolute;left: 240px;top: 260px;text-align: center;font-size: 36px;line-height: 40px;}
  .pic_item .title {position: absolute;top: 320px;left: 240px;display: block;text-align: center;font-size: 36px;line-height: 44px;color: #2d58c6;font-weight: 600;letter-spacing: 12px;}
  .pic_item img {display: block;height: 600px;width: 100%;}
</style>


// WEBPACK FOOTER //
// src/components/HelloWorld.vue